let load = require('./helpers/browser/esm-js-loader-shards-super.js')(4);
module.exports = (load("fGiL4")).then(() => parcelRequire('dFrEV'));